import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { AuthenticationModule } from '@mobileia/authentication';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { fuseConfig } from './system/fuse-config';
import { LayoutFuseModule } from '@mobileia/layout-fuse';

import { SystemComponent } from './system/system.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { environment } from 'src/environments/environment';
import { SliderComponent } from './pages/slider/slider.component';
import { BaseTableComponent } from './pages/base-table/base-table.component';

import { MatIconModule } from '@angular/material/icon'; import { MatButtonModule } from '@angular/material/button'; import { MatInputModule } from '@angular/material/input'; import { MatTableModule } from '@angular/material/table'; import { MatSelectModule } from '@angular/material/select'; import {MatTooltipModule} from '@angular/material/tooltip'; import { MatProgressBarModule } from '@angular/material/progress-bar'; import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';import { MatCardModule } from '@angular/material/card';import { MatMenuModule } from '@angular/material/menu'; import { MatPaginatorModule } from '@angular/material/paginator'; import { MatDividerModule } from '@angular/material/divider';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { FlexLayoutModule } from '@angular/flex-layout';
import { SliderAddComponent } from './pages/slider-add/slider-add.component';
import { BaseAddComponent } from './pages/base-add/base-add.component';
import { CategoryComponent } from './pages/category/category.component';
import { CategoryAddComponent } from './pages/category-add/category-add.component';
import { ProductComponent } from './pages/product/product.component';
import { ProductAddComponent } from './pages/product-add/product-add.component';
import { ProductRelatedComponent } from './pages/product-related/product-related.component';
import { BaseRelatedComponent } from './pages/base-related/base-related.component';
import { TransactionComponent } from './pages/transaction/transaction.component';
import { TransactionViewComponent } from './pages/transaction-view/transaction-view.component';
import { BaseViewComponent } from './pages/base-view/base-view.component';
import { SectionComponent } from './pages/section/section.component';
import { BaseSectionEditComponent } from './pages/base-section-edit/base-section-edit.component';
import { SectionEditFourComponent } from './pages/section-edit-four/section-edit-four.component';
import { HelpboxComponent } from './pages/helpbox/helpbox.component';
import { HelpboxAddComponent } from './pages/helpbox-add/helpbox-add.component';
import { PagetagComponent } from './pages/pagetag/pagetag.component';
import { PagetagAddComponent } from './pages/pagetag-add/pagetag-add.component';
import { SectionEditOneComponent } from './pages/section-edit-one/section-edit-one.component';
import { SectionEditTwoComponent } from './pages/section-edit-two/section-edit-two.component';
import { SectionEditThreeComponent } from './pages/section-edit-three/section-edit-three.component';
import { MAT_DATE_FORMATS, NativeDateModule } from '@angular/material/core';
import { PaymentDiscountComponent } from './pages/payment-discount/payment-discount.component';
import { PaymentDiscountAddComponent } from './pages/payment-discount-add/payment-discount-add.component';
import { PaymentInstallmentComponent } from './pages/payment-installment/payment-installment.component';
import { PaymentInstallmentAddComponent } from './pages/payment-installment-add/payment-installment-add.component';
import { SectionEditFiveComponent } from './pages/section-edit-five/section-edit-five.component';
import { ProductDiscountComponent } from './pages/product-discount/product-discount.component';
import { ProductDiscountAddComponent } from './pages/product-discount-add/product-discount-add.component';
import { SynonymGroupComponent } from './pages/synonym-group/synonym-group.component';
import { SynonymGroupAddComponent } from './pages/synonym-group-add/synonym-group-add.component';

@NgModule({
  declarations: [
    AppComponent,
    SystemComponent,
    DashboardComponent,
    SliderComponent,
    BaseTableComponent,
    SliderAddComponent,
    BaseAddComponent,
    CategoryComponent,
    CategoryAddComponent,
    ProductComponent,
    ProductAddComponent,
    ProductRelatedComponent,
    BaseRelatedComponent,
    TransactionComponent,
    TransactionViewComponent,
    BaseViewComponent,
    SectionComponent,
    BaseSectionEditComponent,
    SectionEditFourComponent,
    HelpboxComponent,
    HelpboxAddComponent,
    PagetagComponent,
    PagetagAddComponent,
    SectionEditOneComponent,
    SectionEditTwoComponent,
    SectionEditThreeComponent,
    PaymentDiscountComponent,
    PaymentDiscountAddComponent,
    PaymentInstallmentComponent,
    PaymentInstallmentAddComponent,
    SectionEditFiveComponent,
    ProductDiscountComponent,
    ProductDiscountAddComponent,
    SynonymGroupComponent,
    SynonymGroupAddComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    AuthenticationModule.forRoot({ apiKey: "0", isInternal: true, baseUrlInternal: environment.baseUrl}),
    SweetAlert2Module.forRoot(),
    BrowserAnimationsModule,
    LayoutFuseModule.forRoot(fuseConfig),
    FlexLayoutModule,

    MatMenuModule, MatCardModule, MatIconModule, MatTableModule, MatButtonModule, MatInputModule, MatSelectModule, MatTooltipModule, MatProgressBarModule, MatProgressSpinnerModule, MatDatepickerModule, NativeDateModule, MatPaginatorModule, MatDividerModule
  ],
  providers: [
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
